<template>
  <v-card 
    :class="{ 'elevation-0'  : overview }"
    class="px-4 pb-4 pt-0">
    <v-layout row align-center justify-space-between>
      <v-flex xs12 class="month-year layout row wrap">
        <p class="py-3 pr-3 ma-0">
          {{$lang.labels.company}}:
          <span class="ml-2">{{ allDetails.companyName }}</span>
        </p>
        <p class="pa-3 ma-0">
          {{$lang.labels.month}}:
          <span class="ml-2">{{ allDetails.month }}</span>
        </p>
        <p class="pa-3 ma-0">
          {{$lang.labels.year}}:
          <span class="ml-2">{{ allDetails.year }}</span>
        </p>
      </v-flex>
      <v-btn
        v-if="!overview"
        flat 
        fab 
        small 
        @click="$emit('close')" 
        aria-label="Close">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
    <v-flex xs12 class="my-2" v-if="err">
      <v-alert :value="true" type="error">{{err}}</v-alert>
    </v-flex>

    <div class="v-table__overflow" v-if="webShopResources.length > 0">
      <table class="v-datatable v-table theme--light my-table-2">
        <tbody>
          <template v-for="(resource, index) in webShopResources">
            <tr :key="index">
              <td>
                Webshop: 
                <template v-if="resource.weShopResourceName">
                  <strong>{{ resource.weShopResourceName}}</strong>
                </template>
                ({{ resource.webShopResourceId }})
              </td>
              <td />
            </tr>
            <template v-for="(pricing, index) in resource.pricingPerSubscriptionModel">
              <tr :key="index">
                <td>
                  Subscription: {{ pricing.type }}
                </td>
                <td />
              </tr>
              <template v-for="(subPricing, i) in pricing.monthlySubscriptionPricing">
                <tr :key="i">
                  <td class="nested">Time range ({{ subPricing.noOfDaysCharged }} days):</td>
                  <td class="amount">{{ formatDate(subPricing.fromDate) }} - {{ formatDate(subPricing.toDate) }}</td>
                </tr>
              </template>
              <tr :key="index">
                <td class="nested">One time charges</td>
                <td class="amount"> {{ pricing.onetimeCharges || 0 }} </td>
              </tr>
              <template 
                v-if="pricing.monthlySubscriptionPricing"
                v-for="(monthly, index) in pricing.monthlySubscriptionPricing">
                <tr :key="index">
                  <td>Monthly Charges</td>
                  <td class="amount">{{ monthly.calculatedMonthlyCharge || 0 }}</td>
                </tr>
                <tr :key="index">
                  <td>Monthly subscription</td>
                  <td/>
                </tr>
                <tr :key="index">
                  <td class="nested">Fixed fee:</td>
                  <td class="amount">{{ monthly.monthlyFixedCharges ? monthly.monthlyFixedCharges : '0'}}</td>
                </tr>
              </template>
              <template v-if="pricing.revenueBasedPricing">
                <tr :key="index">
                  <td class="nested">Charges on revenue: (total revenue {{pricing.revenueBasedPricing.totalRevenue}}, 
                    number of orders {{pricing.revenueBasedPricing.noOfOrdersPlaced}})</td>
                  <td>{{ pricing.revenueBasedPricing.chargesOnRevenue }}</td>
                </tr>
              </template>
            </template>
            <tr class="total" :key="index">
              <td><strong>Total for Resource</strong></td>
              <td class="amount">{{ resource.totalCharges }}</td>
            </tr>
            <tr :key="index" class="spacing"></tr>
          </template>
        </tbody>
      </table>
    </div>

    <div class="v-table__overflow pt-4" v-if="moonLicensePricing.length > 0">
      <table class="v-datatable v-table theme--light my-table-2">
        <tbody>
          <template v-for="(license, index) in moonLicensePricing">
            <tr :key="index">
              <td>Moon: ({{ license.licenseId }})</td>
              <td />
            </tr>
            <tr :key="index">
              <td>Subscription: {{ license.licenseType }}</td>
              <td />
            </tr>
            <template v-for="(pricing, index) in license.license">
              <tr :key="index">
                <td>Time range ({{ pricing.noOfDaysCharged }} days):</td>
                <td class="amount">{{ formatDate(pricing.fromDate) }} - {{ formatDate(pricing.toDate) }}</td>
              </tr>
              <tr :key="index">
                <td>License:</td>
                <td />
              </tr>
              <tr :key="index">
                <td class="nested">One time charges:</td>
                <td class="amount">{{ pricing.licenseBase.onetimeCharges || 0 }}</td>
              </tr>
              <tr :key="index">
                <td class="nested">Monthly charges:</td>
                <td class="amount">{{ pricing.licenseBase.monthlyCharges  || 0 }}</td>
              </tr>
              <tr :key="index">
                <td>
                  Concurrent users ({{ pricing.concurrentUsers.noOfConcurrentUsersCharged || 0 }} charged out of 
                  {{ pricing.concurrentUsers.noOfConcurrentUsersTotal || 0 }} total):
                </td>
                <td />
              </tr>
              <tr :key="index">
                <td class="nested">One time charges:</td>
                <td class="amount">{{ pricing.concurrentUsers.onetimeCharges }}</td>
              </tr>
              <tr :key="index">
                <td class="nested">Monthly charges:</td>
                <td class="amount">{{ pricing.concurrentUsers.monthlyCharges }}</td>
              </tr>
            </template>
            <tr class="total" :key="index">
              <td><strong>Total for resources</strong></td>
              <td class="amount"> {{ license.totalCharges }} </td>
            </tr>
            <tr :key="index" class="spacing"></tr>
          </template>
        </tbody>
      </table>
    </div>

    <div class="v-table__overflow pt-4" v-if="webSpacePricing.length > 0">
      <table class="v-datatable v-table theme--light my-table-2">
        <tbody>
          <template v-for="(webspace, index) in webSpacePricing">
            <tr :key="index">
              <td>Webspace: ({{ webspace.webSpaceId }})</td>
              <td />
            </tr>
            <template v-for="(pricing, index2) in webspace.pricingPerWebSpaceType">
              <tr :key="index2">
                <td>Subscription: {{ pricing.type }}</td>
                <td />
              </tr>
              <template v-for="(webPricing, i) in pricing.monthlyWebSpaceTypePricing">
                <tr :key="i">
                  <td class="nested">Time range ({{ webPricing.noOfDaysCharged }} days):</td>
                  <td class="amount">{{ formatDate(webPricing.fromDate) }} - {{ formatDate(webPricing.toDate) }}</td>
                </tr>
              </template>
              <tr :key="index2">
                <td class="nested">One time charges:</td>
                <td class="amount">{{ pricing.onetimeCharges || 0 }}</td>
              </tr>
              <tr :key="index2">
                <td class="nested">Monthly charges:</td>
                <td class="amount">{{ pricing.totalMonthlyCharges || 0 }}</td>
              </tr>
            </template>
            <tr class="total" :key="index">
              <td><strong>Total for resources</strong></td>
              <td class="amount">{{ webspace.totalCharges }}</td>
            </tr>
            <tr :key="index" class="spacing"></tr>
          </template>
        </tbody>
      </table>
    </div>

    <div class="v-table__overflow pt-4" v-if="domainPricing.length > 0">
      <table class="v-datatable v-table theme--light my-table-2">
        <tbody>
          <template v-for="(domain, index) in domainPricing">
            <tr :key="index">
              <td>Domain: <strong>{{domain.domainName}}</strong> ({{ domain.domainId }})</td>
              <td />
            </tr>
            <template v-for="pricing in domain.pricingPerDomainType">
              <template v-for="(monthly, index) in pricing.monthlyDomainTypePricing">
                <tr :key="index">
                  <td>Subscription: {{ pricing.type }}</td>
                  <td />
                </tr>
                <tr :key="index">
                  <td class="nested">Time range ({{ monthly.noOfDaysCharged }} days):</td>
                  <td class="amount">{{ formatDate(monthly.fromDate) }} - {{ formatDate(monthly.toDate) }}</td>
                </tr>
                <tr :key="index">
                  <td class="nested">One time charges:</td>
                  <td class="amount">{{ monthly.monthlyFixedCharges || 0 }}</td>
                </tr>
                <tr :key="index">
                  <td class="nested">Monthly charges:</td>
                  <td class="amount">{{ monthly.calculatedMonthlyCharge || 0 }}</td>
                </tr>
              </template>
            </template>
            <tr class="total" :key="index">
              <td>Subtotal</td>
              <td class="amount">{{ domain.totalChargesBeforeDiscount }}</td>
            </tr>
            <tr :key="index" v-if="domain.discount">
              <td>Discount ({{domain.discountedDays}} days)</td>
              <td class="amount">-{{ domain.discount }}</td>
            </tr>
            <tr class="total" :key="index">
              <td><strong>Total for resources</strong></td>
              <td class="amount">{{ domain.totalCharges }}</td>
            </tr>
            <tr :key="index" class="spacing"></tr>
          </template>
        </tbody>
      </table>
    </div>

    <div class="v-table__overflow pt-4" v-if="individualApp.length > 0">
      <table class="v-datatable v-table theme--light my-table-2">
        <tbody>
          <template v-for="(resource, index) in individualApp">
            <tr :key="index">
              <td>
                App: 
                <template v-if="resource.appResourceName">
                  <strong>{{ resource.appResourceName}}</strong>
                </template>
                ({{ resource.appResourceId }})
              </td>
              <td />
            </tr>
            <tr :key="index">
              <td>Type: {{ resource.appResourceType }}</td>
              <td />
            </tr>
            <template v-for="(pricing, index2) in resource.appResourcePricingPerSubscriptionModel">
              <tr :key="index2">
                <td>Subscription: {{ pricing.type }}</td>
                <td />
              </tr>
              <template v-for="(monthlyPricing, i) in pricing.monthlySubscriptionPricing">
                <tr :key="i">
                  <td class="nested">Time range ({{ monthlyPricing.noOfDaysCharged }} days):</td>
                  <td class="amount">{{ formatDate(monthlyPricing.fromDate) }} - {{ formatDate(monthlyPricing.toDate) }}</td>
                </tr>
              </template>
              <tr :key="index2">
                <td class="nested">One time charges:</td>
                <td class="amount">{{ pricing.onetimeCharges || 0 }}</td>
              </tr>
              <template 
                v-if="pricing.monthlySubscriptionPricing"
                v-for="(monthly, index) in pricing.monthlySubscriptionPricing">
                <tr :key="index">
                  <td>Monthly Charges</td>
                  <td class="amount">{{ monthly.calculatedMonthlyCharge || 0 }}</td>
                </tr>
                <tr :key="index">
                  <td>Monthly subscription</td>
                  <td/>
                </tr>
                <tr :key="index">
                  <td class="nested">Fixed fee:</td>
                  <td class="amount">{{ monthly.monthlyFixedCharges ? monthly.monthlyFixedCharges : '0'}}</td>
                </tr>
              </template>
              <template v-if="pricing.revenueBasedPricing">
                <tr :key="index2">
                  <td class="nested">Charges on revenue: (total revenue {{pricing.revenueBasedPricing.totalRevenue}}, 
                    number of orders {{pricing.revenueBasedPricing.noOfOrdersPlaced}})</td>
                  <td class="amount">{{ pricing.revenueBasedPricing.chargesOnRevenue }}</td>
                </tr>
              </template>
            </template>
            <tr class="total" :key="index">
              <td><strong>Total for Resource</strong></td>
              <td class="amount">{{ resource.totalCharges }}</td>
            </tr>
            <tr :key="index" class="spacing"></tr>
          </template>
        </tbody>
      </table>
    </div>

    <div class="v-table__overflow pt-4" v-if="restaurantApp.length > 0">
      <table class="v-datatable v-table theme--light my-table-2">
        <tbody>
          <template v-for="(resource, index) in restaurantApp">
            <tr :key="index">
              <td>
                App: 
                <template v-if="resource.appResourceName">
                  <strong>{{ resource.appResourceName}}</strong>
                </template>
                ({{ resource.appResourceId }})
              </td>
              <td />
            </tr>
            <tr :key="index">
              <td>Type: {{ resource.appResourceType }}</td>
              <td />
            </tr>
            <template v-for="(pricing, index2) in resource.appResourcePricingPerSubscriptionModel">
              <tr :key="index2">
                <td>Subscription: {{ pricing.type }}</td>
                <td />
              </tr>
              <template v-for="(monthlyPricing, i) in pricing.monthlySubscriptionPricing">
                <tr :key="i">
                  <td class="nested">Time range ({{ monthlyPricing.noOfDaysCharged }} days):</td>
                  <td class="amount">{{ formatDate(monthlyPricing.fromDate) }} - {{ formatDate(monthlyPricing.toDate) }}</td>
                </tr>
              </template>
              <tr :key="index2">
                <td class="nested">One time charges:</td>
                <td class="amount">{{ pricing.onetimeCharges || 0 }}</td>
              </tr>
              <template 
                v-if="pricing.monthlySubscriptionPricing"
                v-for="(monthly, index) in pricing.monthlySubscriptionPricing">
                <tr :key="index">
                  <td>Monthly Charges</td>
                  <td class="amount">{{ monthly.calculatedMonthlyCharge || 0 }}</td>
                </tr>
                <tr :key="index">
                  <td>Monthly subscription</td>
                  <td/>
                </tr>
                <tr :key="index">
                  <td class="nested">Fixed fee:</td>
                  <td class="amount">{{ monthly.monthlyFixedCharges ? monthly.monthlyFixedCharges : '0'}}</td>
                </tr>
              </template>
              <template v-if="pricing.revenueBasedPricing">
                <tr :key="index2">
                  <td class="nested">Charges on revenue: (total revenue {{pricing.revenueBasedPricing.totalRevenue}}, 
                    number of orders {{pricing.revenueBasedPricing.noOfOrdersPlaced}})</td>
                  <td class="amount">{{ pricing.revenueBasedPricing.chargesOnRevenue }}</td>
                </tr>
              </template>
            </template>
            <tr class="total" :key="index">
              <td><strong>Total for Resource</strong></td>
              <td class="amount">{{ resource.totalCharges }}</td>
            </tr>
            <tr :key="index" class="spacing"></tr>
          </template>
        </tbody>
      </table>
    </div>
    <div class="v-table__overflow pt-2">
      <table class="v-datatable v-table theme--light my-table-2">
        <tbody>
          <tr>
            <td><strong>Total:</strong></td>
            <td class="amount"><strong>{{allDetails.totalAmount}} {{allDetails.currency === 'GBP' ? '&pound;' : '&euro;' }}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-card>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    props: ['invoiceId', 'overview'],
    data() {
      return {
        err: '',
        allDetails: null,
        webShopResources: [],
        webSpacePricing: [],
        moonLicensePricing: [],
        domainPricing: [],
        individualApp: [],
        restaurantApp: [],
      };
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd');
      },
      objToArr(type) {
        if (!type) return [];
        let array = [];
        const keys = Object.keys(type);
        keys.forEach(key =>
          array.push(Object.assign({}, type[key])));
        return array;
      },
    },
    created() {
      this.$http.get(`pricinggroupinvoice/${this.invoiceId}`)
        .then((res) => {
          if(res.body.status === 'Success') {
            const details = res.body.details;
            this.allDetails = details;
            if (details.webShopResourcePricing) {
              this.webShopResources = details.webShopResourcePricing.map((data) => {
                const keys = Object.keys(data.pricingPerSubscriptionModel);
                const pricingPerSubscriptionModel = keys.map(key => ({
                  ...data.pricingPerSubscriptionModel[key],
                  type: key,
                }));
                return { ...data, pricingPerSubscriptionModel };
              });
            }
            if (details.webSpacePricing) {
              this.webSpacePricing = details.webSpacePricing.map((data) => {
                const keys = Object.keys(data.pricingPerWebSpaceType);
                const pricingPerWebSpaceType = keys.map(key => ({
                  ...data.pricingPerWebSpaceType[key],
                  type: key,
                }));
                return { ...data, pricingPerWebSpaceType };
              });
            }
            if (details.moonLicensePricing) {
              this.moonLicensePricing = details.moonLicensePricing;
            }
            if (details.domainPricing) {
              this.domainPricing = details.domainPricing.map((data) => {
                const keys = Object.keys(data.pricingPerDomainType);
                const pricingPerDomainType = keys.map(key => ({
                  ...data.pricingPerDomainType[key],
                  type: key,
                }));
                return { ...data, pricingPerDomainType };
              });
            }
            if (details.appResourcePricing) {
              if (details.appResourcePricing.individualOrderApp) {
                this.individualApp = details.appResourcePricing.individualOrderApp.map((data) => {
                  const keys = Object.keys(data.appResourcePricingPerSubscriptionModel);
                  const appResourcePricingPerSubscriptionModel = keys.map(key => ({
                    ...data.appResourcePricingPerSubscriptionModel[key],
                    type: key,
                  }));
                  return { ...data, appResourcePricingPerSubscriptionModel };
                });
              }
              if (details.appResourcePricing.restaurantOrderApp) {
                this.restaurantApp = details.appResourcePricing.restaurantOrderApp.map((data) => {
                  const keys = Object.keys(data.appResourcePricingPerSubscriptionModel);
                  const appResourcePricingPerSubscriptionModel = keys.map(key => ({
                    ...data.appResourcePricingPerSubscriptionModel[key],
                    type: key,
                  }));
                  return { ...data, appResourcePricingPerSubscriptionModel };
                });
              }
            }
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
    },
  };
</script>
<style lang="scss">
  .my-table-2 {
    thead th {
      height: auto !important;
      padding: 7px 10px !important;
    }
    tbody td {
      height: auto !important;
      padding: 10px !important;
    }
    tbody td.nested {
      padding-left: 30px !important;
    }
    tbody tr.total {
      border-top: 2px solid #FFAF00 !important;
    }
    tbody tr.spacing {
      height: 20px;
    }
    .amount {
      width: 250px;
    }
  }
</style>

<style lang="scss" scoped>

  .month-year {
    p {
      font-size: 24px;
      color: #FFB300;
    }
    span {
      color: rgba(#000, 0.67);
    }
  }
</style>



// WEBPACK FOOTER //
// InvoiceDetails.vue?f0ed13bc